import { NodeMaterialDto } from "@api/apiClient";
import { useMemo } from "react";

type NodeMaterialMap = Map<string, NodeMaterialDto> | Map<number, NodeMaterialDto>;

/**
 * Collects unique co2MaterialTypeIds from assigned node materials.
 * Used to scope emission-factor fetches to materials actually referenced in the current analysis context.
 */
export function useAssignedCo2MaterialTypeIds(
  nodeMaterialLookup: NodeMaterialMap | undefined
): string[] {
  return useMemo(() => {
    const ids = new Set<string>();
    nodeMaterialLookup?.forEach((material) => {
      if (material.co2MaterialTypeId) {
        ids.add(material.co2MaterialTypeId);
      }
    });
    return Array.from(ids);
  }, [nodeMaterialLookup]);
}
